module.exports = __webpack_public_path__ + "img/clipboard-x.c515621a.svg";